
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { UnderWritingData } from '../../model/lifestyle.post.model';

export const ADD_LIFESTYLE_RESULT = '[LIFESTYLE] Add';
export const REMOVE_LIFESTYLE_RESULT = '[LIFESTYLE] Remove';

// AddPersonalDetails
export class AddLifestyleResult implements Action {
    readonly type = ADD_LIFESTYLE_RESULT;

    constructor(public payload: UnderWritingData) { }
}
// RemovePersonalDetails
export class RemoveLifestyleResult implements Action {
    readonly type = REMOVE_LIFESTYLE_RESULT;

    constructor(public payload: number) { }
}

export type Actions = AddLifestyleResult | RemoveLifestyleResult;
